export default "__VITE_ASSET__4171dfe2__"